import React from "react";
import { Container, Typography, Box, Alert, Divider, Chip, Stack } from "@mui/material";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faGavel, faUsers, faArrowRightLong, faHandshake } from "@fortawesome/free-solid-svg-icons";

const POST20240625: React.FC = () => {
    return (
        <Container sx={{ mb: 5 }}>
            <SectionTitle title={"ESPACE INFORMATIONS DES HABITANTS"} />

            <Box mt={3}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    PLUi de Bois-le-Roi, épisode 3
                </Typography>

                <Divider sx={{ my: 2 }}>
                    <Chip color="error" label="Tension accrue" icon={<FontAwesomeIcon icon={faExclamationTriangle} />} />
                </Divider>

                <Typography variant="body1" paragraph>
                    La tension est encore montée d’un cran lundi 24 juin 2024 à l&apos;occasion de la troisième réunion sur le PLUi de Bois-le-Roi.
                    <strong> Le Maire n’avait pas les arguments et s’est fait hué à plusieurs reprises.</strong>
                </Typography>

                <Alert severity="warning" icon={<FontAwesomeIcon icon={faGavel} />}>
                    Les habitants, de plus en plus informés, dénoncent un projet PLUi considéré par beaucoup comme une <b>spoliation irrémédiable</b> de leur patrimoine.
                </Alert>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    Un projet d’habitation est un projet de vie, de famille, une transmission. <b>Les habitants sont attaqués en plein cœur.</b>
                </Typography>

                <Alert severity="error" sx={{ my: 2 }}>
                    <b>
                        Comment le Maire et ses adjoints ont-ils pu dissimuler aux habitants un projet de cette ampleur ?
                    </b>
                    <br />
                    <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
                        <li>Interdiction à des propriétaires de construire sur leurs terrains.</li>
                        <li>Obligation de logements sociaux sous peine de cession à prix cassé (secteur de mixité sociale).</li>
                    </ul>
                    <FontAwesomeIcon icon={faUsers} style={{ marginRight: 8 }} />
                    <i>Une grave atteinte au droit de propriété et à la citoyenneté.</i>
                </Alert>

                <Box my={2}>
                    <Typography variant="body2" color="text.secondary">
                        Beaucoup de propriétaires voient leurs terrains passer en zones non constructibles : <b>une vie de travail réduite à néant.</b>
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Typography variant="body1" paragraph>
                    L&apos;équipe municipale n’a sans doute pas atteint l&apos;apogée de son manque d&apos;empathie et d&apos;incompétence.
                    <br />
                    <b>
                        <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#c62828", marginRight: 6 }} />
                        Attention : la quatrième réunion du mercredi 26/06 à 19h30 en Mairie s&apos;annonce houleuse.
                    </b>
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Box my={2}>
                    <Stack spacing={2}>
                        <Alert severity="info" icon={<FontAwesomeIcon icon={faGavel} />}>
                            Dans un souci d’apaisement, l’association <b>VIVRE LA DEMOCRATIE A BLR</b> demande formellement :</Alert>

                        <Typography variant="body1" mb={1}>
                            <FontAwesomeIcon icon={faArrowRightLong} color="#1976d2" style={{ marginRight: 6 }} />
                            <b>RETRAIT et report du PLUi</b> de Bois-le-Roi du vote prévu le 27/06 au Conseil d’agglomération,
                            <br />
                            le temps d’organiser une phase réglementaire de concertation réelle avec habitants et associations.
                        </Typography>
                    </Stack>
                </Box>

                <Typography variant="body1" paragraph sx={{ mt: 3 }}>
                    <b>Non à la dégradation du PLU actuel</b> au seul profit de la densification !
                    <br />
                    Préservons notre patrimoine environnemental et notre cadre de vie.
                </Typography>

                <Box mt={3}>
                    <Alert severity="info" icon={<FontAwesomeIcon icon={faHandshake} />}>
                        La CAPF doit garantir la <b>méthodologie</b> correcte du Projet PLUi et sa déclinaison réglementaire.
                    </Alert>
                </Box>

                <Box my={4}>
                    <Typography variant="body1">
                        <b>Sortir par le haut :</b>
                    </Typography>
                    <Typography variant="body2" color="primary" sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                        <FontAwesomeIcon icon={faArrowRightLong} style={{ marginRight: 8 }} />
                        <u>Nomination d’un médiateur indépendant</u>
                        &nbsp;pour accompagner la commune dans un projet de PLUi accepté par toutes et tous.
                    </Typography>
                </Box>

                <Alert severity="success" sx={{ mt: 3 }}>
                    <b>Bon exemple :</b> Le Maire de Chartrettes a su définir et partager les objectifs collectifs du PLUi avec ses administrés.
                </Alert>
            </Box>
        </Container>
    );
};

export default POST20240625;